module.exports = __webpack_public_path__ + "img/symbol-fx-left.5170daf3.png";